module.exports = __webpack_public_path__ + "app-store-black.svg?dbfdad257c49eb01333e33e7e5a544f3";